const repairStatisticsRouter = {
  title: '维修统计',
  type: 'view',
  name: Symbol('repairStatistics'),
  route: '/repair/statistics',
  filePath: 'view/order/repairStatistics.vue',
  inNav: false,
  icon: 'iconfont icon-tongji',
  sortId: 99,
}

export default repairStatisticsRouter
